// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3VGzK","box":"WorkspacesBox_box__tP2XF","node":"WorkspacesBox_node__3amLC"};